export default {
    send(product, programCode, isSkipForm){
        let data  = {
            formType: "",
            formSubType: "",
            programCode: programCode,
            product: product[0],
            skipform: isSkipForm ? 1 : 0
        }
        data = this.getVars(data)
        console.log("SMART FORM: GA Conversion DATA", data)

        if(typeof _satellite !== 'undefined'){
            _satellite.setVar('formType', data.formType);
            _satellite.setVar('formSubType', data.formSubType);
            _satellite.setVar('programCode', data.programCode);
            _satellite.setVar('product', data.product);
            _satellite.setVar('skipform', data.skipform);
            _satellite.track('form submitted');
            console.log("SMART FORM: GA Conversion Sent", data)
        }

        //how are you recording values for product, format lowercase - separated ?

    },
    getVars(data){
        let url = document.URL

        data.formType = 'gated content',
        data.formSubType = 'unknown'

        // Set vars by URL
        if(url.match('\/lp\/secure\/try/\download\-')){
            data.formType = 'trial';
            data.formSubType = 'diy trial';
        }else if(url.match('request-a-demo')){
            data.formType = 'request a demo';
            data.formSubType = 'demo';
        }else if(url.match('\/form\/.*trial')){
            data.formType = 'trial';
            data.formSubType = 'other trial';
        }else if(url.match('/form\/inquiry')){
            data.formType = 'inquiry';
        }else if(url.indexOf('/form/') > -1){
            data.formSubType = this.gatedContentSubType(url);
        }else if(url.indexOf('/lp/') > -1){
            data.formSubType = this.gatedContentSubType(url)
        }
        return data
    },
    gatedContentSubType(url){
        let formSubType = 'unknown';
        if(url.match(/analyst-report|gartner|forrester|idc|esg|tolly/i)){
            formSubType = 'analyst report';
        }else if(url.match(/calculator/i)){
            formSubType = 'calculator';
        }else if(url.match(/casestudy/i)){
            formSubType = 'case study';
        }else if(url.match(/ebook/i)){
            formSubType = 'ebook';
        }else if(url.match(/newsletter/i)){
            formSubType = 'newsletter';
        }else if(url.match(/kit/i)){
            formSubType = 'kit';
        }else if(url.match(/inquiry/i)){
            formSubType = 'inquiry';
        }else if(url.match(/techpreview/i)){
            formSubType = 'tech preview';
        }else if(url.match(/webinar|class|training/i)){
            formSubType = 'events';
        }else if(url.match(/trial/i)){
            formSubType = 'trial';
        }else if(url.match(/whitepaper/i)){
            formSubType = 'white paper';
        }else if(url.match(/workbook/i)){
            formSubType = 'workbook';
        }else if(url.match(/demo/i)){
            formSubType = 'demo';
        }
        return formSubType;
    }
}


